import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ReportsPage = () => {
  const [reportType, setReportType] = useState("daily");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const navigate = useNavigate();

  const handleExport = (e) => {
    e.preventDefault();
    console.log("Exporting:", reportType, fromDate, toDate);
  };

  const handleDownloadInvoice = (orderId) => {
    console.log("Download Invoice for:", orderId);
    navigate("/Seller-invoice");
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Reports</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li className="breadcrumb-item active">Reports</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Report Export Section */}
        <form onSubmit={handleExport}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Export Orders</label>
              <select
                className="form-select"
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
                required
              >
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="range">Custom Date Range</option>
              </select>
            </div>

            {reportType === "range" && (
              <>
                <div className="col-md-3 mb-3">
                  <label className="form-label">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    required
                  />
                </div>
              </>
            )}
            <div className="text-end col-md-6">
            <button type="submit" className="btn btn-primary">Export Report</button>
          </div>
          </div>
        </form>

        {/* Statement Section */}
        <div className="row mt-4">
          <div className="col-md-6 mb-3">
            <h5 className="fw-semibold">Statements</h5>
            <button className="btn btn-outline-success me-2" onClick={() => alert("Download Prepaid Orders")}>
              Prepaid Orders
            </button>
            <button className="btn btn-outline-info" onClick={() => alert("Download COD Orders")}>
              COD Orders
            </button>
          </div>
        </div>

        {/* GST Invoice Section */}
        <div className="row mt-4">
          <div className="col-12">
            <h5 className="fw-semibold mb-3">GST Invoices</h5>
            <p className="text-muted">Download GST invoices for delivered orders (excluding returns)</p>

            <div className="table-responsive card">
              <table className="table table-bordered mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>Amount</th>
                    <th>Download Invoice</th>
                  </tr>
                </thead>
                <tbody>
                  {["ORD001", "ORD002"].map((id, index) => (
                    <tr key={index}>
                      <td>{id}</td>
                      <td>John Doe</td>
                      <td>₹999</td>
                      <td>
                        <button className="btn btn-sm btn-outline-primary" onClick={() => handleDownloadInvoice(id)}>
                          Download
                        </button>
                      </td>
                    </tr>
                  ))}
                  {/* Replace with dynamic invoice data */}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer mt-4 text-center">
          <div className="container-fluid">© 2025 Seller Portal</div>
        </footer>
      </div>
    </div>
  );
};

export default ReportsPage;
